import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import Skeleton from 'react-loading-skeleton';
import { type MembershipRequirementsPerYear } from '../../../../utils/types/membership-requirements';
export const useDataFieldRenderer = t0 => {
  const $ = _c(7);
  const {
    basedOnSelectedCountry: t1,
    countryYearData,
    isFetching
  } = t0;
  const basedOnSelectedCountry = t1 === undefined ? true : t1;
  const locale = useLocale();
  let t2;
  if ($[0] !== locale) {
    t2 = new Intl.NumberFormat(locale);
    $[0] = locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const numberFormatter = t2;
  let t3;
  if ($[2] !== basedOnSelectedCountry || $[3] !== countryYearData?.currencyCode || $[4] !== isFetching || $[5] !== numberFormatter) {
    const renderDataField = value => {
      if (isFetching) {
        return <Skeleton style={{
          position: "relative",
          zIndex: -1
        }} />;
      }
      if (!value) {
        return;
      }
      if (basedOnSelectedCountry) {
        if (!countryYearData?.currencyCode) {
          return;
        }
        return `${numberFormatter.format(Number(value))} ${countryYearData?.currencyCode}`;
      }
      return `${numberFormatter.format(Number(value))} USD`;
    };
    t3 = {
      renderDataField
    };
    $[2] = basedOnSelectedCountry;
    $[3] = countryYearData?.currencyCode;
    $[4] = isFetching;
    $[5] = numberFormatter;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};